import { css } from 'lit';
export const dividerStyles = css `
    :host([orientation='horizontal']) {
        display: block;
    }
    :host([orientation='horizontal'][size='small'][color='weak-1']) {
        border-top: 1px solid var(--hlx-border-color-weak-1);
    }
    :host([orientation='horizontal'][size='small'][color='strong-1']) {
        border-top: 1px solid var(--hlx-border-color-strong-1);
    }
    :host([orientation='horizontal'][size='small'][color='inverted']) {
        border-top: 1px solid var(--hlx-border-color-inverted);
    }
    :host([orientation='horizontal'][size='medium'][color='weak-1']) {
        border-top: 2px solid var(--hlx-border-color-weak-1);
    }
    :host([orientation='horizontal'][size='medium'][color='strong-1']) {
        border-top: 2px solid var(--hlx-border-color-strong-1);
    }
    :host([orientation='horizontal'][size='medium'][color='inverted']) {
        border-top: 2px solid var(--hlx-border-color-inverted);
    }

    :host([orientation='vertical']) {
        position: relative;
        /* See https://exas.atlassian.net/browse/HLX-730
        Do not remove margin otherwise browser will shrink height to 0 */
        margin: 0 var(--hlx-spacing-xs);
    }
    :host([orientation='vertical']):after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
    }
    :host([orientation='vertical'][size='small'][color='weak-1']):after {
        width: 1px;
        background: var(--hlx-border-color-weak-1);
    }
    :host([orientation='vertical'][size='small'][color='strong-1']):after {
        width: 1px;
        background: var(--hlx-border-color-strong-1);
    }
    :host([orientation='vertical'][size='small'][color='inverted']):after {
        width: 1px;
        background: var(--hlx-border-color-inverted);
    }
    :host([orientation='vertical'][size='medium'][color='weak-1']):after {
        width: 2px;
        background: var(--hlx-border-color-weak-1);
    }
    :host([orientation='vertical'][size='medium'][color='strong-1']):after {
        width: 2px;
        background: var(--hlx-border-color-strong-1);
    }
    :host([orientation='vertical'][size='medium'][color='inverted']):after {
        width: 2px;
        background: var(--hlx-border-color-inverted);
    }
`;
//# sourceMappingURL=divider.styles.js.map